import {
  Activity,
  ScreenActivity,
  ActivityModel
} from '../../models/activities/activity';
import { Contractor } from '../contractor';
import { ContractorType } from '../contractor-type';

export class ContractorSelectionVM {
  contractorTypeId: string;
  selectedContractorId: string;
  selectedContractorBusinessName: string;
  notInList: boolean;
  selectedRegistrationId: string;
}

export class ContractorSelectionActivityModel extends ActivityModel {
  public contractorSelection: ContractorSelectionVM;
  public allowNotListedOption: boolean;

  constructor(options?: Partial<ContractorSelectionActivityModel>) {
    super(options);
    if (options) {
      Object.assign(this, options);
    }
  }
}

export class ContractorSelectionActivity extends ScreenActivity<
  ContractorSelectionActivityModel
> {
  contractorTypeIds: string[];
  contractorTypeDetails: {[key: string]: { id: string, name: string, registerWorkflowId: string, renwalWorkflowId: string }};
  isRequired: boolean;
  canEditContractor: boolean;
  contractor: Contractor;
  availableRegistrations?: any[]

  constructor(options?: Partial<ContractorSelectionActivity>) {
    super(options);
    this.contractorTypeIds = [];
    this.model = new ContractorSelectionActivityModel();
    if (options) {
      Object.assign(this, options);
    }

    this.model = new ContractorSelectionActivityModel(
      options ? options.model : null
    );

    this.model.screenName = this.model.screenName || 'Select contractor';
  }

  override prepareForSave(): void {
    super.prepareForSave();
    this.contractorTypeDetails = null;
  }

}
